import StoreReferrer from './storereferrer';
import { isDevelopmentSite } from './utils';
import { CONSTANTS } from './constants';
import mixpanel from 'mixpanel-browser';
import { useEffect } from 'react';
import './App.css';

function App() {

  useEffect(() => {
    if(!(isDevelopmentSite())){
      mixpanel.init(
        CONSTANTS.MIXPANEL_TOKEN,
        { 
          track_pageview: true,
          persistence: 'localStorage' 
        }
      );
    }
  }, []);

  return (
    <div className="App">
      <header className="App-header">
        <div className='loader'></div>
        <StoreReferrer />
      </header>
    </div>
  );
}

export default App;
